/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import withPageErrorBoundary from '@ion/applications/src/pages/withPageErrorBoundary';
import {isAuthenticatedSelector} from '@/store/selectors/login-selectors';
import changePage, {getPersistedRoute, Route} from '../routes/RouteDefinitions';
import {getDefaultRoute} from '../routes/RouteSecurity';

/**
 * Defines the root level Index Page from which the application is initialized.
 */
const Index = () => {
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  useEffect(() => {
    const route = isAuthenticated ? (
      getPersistedRoute() || getDefaultRoute(Route.TRACKING2)
    ) : Route.LOGIN;
    changePage(route);
  }, [isAuthenticated]);
  return null;
};
export default withTranslation('common')(withPageErrorBoundary(Index));
